import serveFirstLogo from "../assets/images/general/serve-first-new.png";

/** Bundled logo for static <img src={...} /> usage. */
export const SERVE_FIRST_LOGO = serveFirstLogo;

/** Public URL for runtime / API fallback logo paths. */
export const SERVE_FIRST_LOGO_URL = "/images/webRating/serve-first-new.png";
